import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSearch } from '../hooks/useArticles';
import ArticleList from '../components/ArticleList';
import SearchBar from '../components/SearchBar';

export default function Search() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialQuery = searchParams.get('q') || '';
  const [query, setQuery] = useState(initialQuery);

  const { results, loading, totalCount } = useSearch(query);

  const handleSearch = (newQuery: string) => {
    setQuery(newQuery);
    setSearchParams({ q: newQuery });
  };

  useEffect(() => {
    const q = searchParams.get('q');
    if (q && q !== query) {
      setQuery(q);
    }
  }, [searchParams]);

  return (
    <div className="space-y-6">
      {/* ヘッダー */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">記事検索</h1>
        <p className="mt-1 text-sm text-gray-500">
          キーワードで記事を検索（同義語展開対応）
        </p>
      </div>

      {/* 検索バー */}
      <div className="bg-white rounded-lg shadow-sm border p-4">
        <SearchBar initialQuery={query} onSearch={handleSearch} />
      </div>

      {/* 検索結果 */}
      {query && (
        <div>
          <div className="mb-4 flex items-center justify-between">
            <h2 className="text-lg font-medium text-gray-900">
              「{query}」の検索結果
            </h2>
            <span className="text-sm text-gray-500">
              {totalCount}件
            </span>
          </div>

          <ArticleList
            articles={results}
            loading={loading}
            emptyMessage={`「${query}」に一致する記事が見つかりませんでした`}
          />
        </div>
      )}

      {/* 検索ヒント */}
      {!query && (
        <div className="bg-blue-50 rounded-lg p-4">
          <h3 className="text-sm font-medium text-blue-800 mb-2">検索のヒント</h3>
          <ul className="text-sm text-blue-700 space-y-1">
            <li>・「マネロン」と検索すると「マネー・ローンダリング」等の同義語も検索されます</li>
            <li>・「行政処分」「課徴金」などのキーワードで重要記事を探せます</li>
            <li>・会社名や人名での検索も可能です</li>
          </ul>
        </div>
      )}
    </div>
  );
}
